import { SettingsItem, preferencesApi as xPreferencesApi } from '@seeneco-ui/api/modules/preferences';

import { SettingsKey } from './model';

const preferencesApi = {
	fetchNewLeadSmsText: (tenantID: number) => {
		return new Promise<string>(resolve => {
			xPreferencesApi.rest
				.fetchPreferences(tenantID, [SettingsKey.PARTNERS_NEW_LEAD_SMS_TEXT])
				.then((result: Record<string, SettingsItem>) => {
					resolve(result[SettingsKey.PARTNERS_NEW_LEAD_SMS_TEXT]?.value || '');
				});
		});
	},
};

export { preferencesApi };
